import { render, staticRenderFns } from "./ModalTestProcessor.vue?vue&type=template&id=6513a622"
import script from "./ModalTestProcessor.vue?vue&type=script&lang=js"
export * from "./ModalTestProcessor.vue?vue&type=script&lang=js"
import style0 from "./ModalTestProcessor.vue?vue&type=style&index=0&id=6513a622&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports